import { Editor } from '@tiptap/react';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';

export const convertMarkupHtmlToString = (html: string) => {
  const editor = new Editor({
    extensions: [Document, Paragraph, Text],
    editable: false,
    content: html
  });

  return editor.getText({ blockSeparator: '\n' });
};
